import { z } from 'zod';

export const emptySchema = {
  all: (errorMap: z.ZodErrorMap, message: string) =>
    z.union(
      [
        emptySchema.string(errorMap),
        emptySchema.undefined(errorMap),
        emptySchema.null(errorMap),
        emptySchema.object(errorMap, message),
        emptySchema.array(errorMap, message),
      ],
      { errorMap },
    ),

  string: (errorMap: z.ZodErrorMap) => z.literal('', { errorMap }),
  undefined: (errorMap: z.ZodErrorMap) => z.undefined({ errorMap }),
  null: (errorMap: z.ZodErrorMap) => z.null({ errorMap }),
  object: (errorMap: z.ZodErrorMap, message: string) => z.object({}, { errorMap }).strict(message),
  array: (errorMap: z.ZodErrorMap, message: string) => z.array(z.any({ errorMap }), { errorMap }).length(0, message),
};
